var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogsHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.834,
    height: 13.199,
    viewBox: "0 0 18.834 13.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:square;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.068 -334.885)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 14.431,
    transform: "translate(16.069 339.628)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 11.431,
    transform: "translate(16.069 335.885)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 7.431,
    transform: "translate(16.069 343.356)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 16.834,
    transform: "translate(16.069 347.084)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsHistory);
export default __webpack_public_path__ + "static/media/logs-history.beceabf8d15b7f4fae14af9ef87692df.svg";
export { ForwardRef as ReactComponent };